module.exports = __webpack_public_path__ + "img/Producer2.fcdb55ba.png";